import React from "react";
import { Row, Col, Button } from "reactstrap";

function ProfileModal(props) {
  //const instructor = props.instructor;
  const hasImage = props.instructor && props.instructor.imagename && props.instructor.imagename.trim() !== "";


  const location = `${props.instructor.storecity}, ${props.instructor.storestate}`;

  return (
    <>
    <div className="container-fluid p-4">
      <div className="d-flex justify-content-end">
        <button
          type="button"
          onClick={() => props.modalFn(false)}
          style={{
            border: "none",
            background: "none",
            fontSize: "24px",
            fontWeight: "bold",
            cursor: "pointer",
            //padding: "0.5rem 1rem",
          }}
          aria-label="Close"
        >
          ×
        </button>
      </div>
      <Row>
        {/* Left Column */}
        <Col md="6" className="border text-left">
          <div className="d-flex align-items-center" style={{ gap: "1rem", margin: '20px' }}>
            {hasImage ? (
              <img
                src={props.instructor.imagename}
                alt={props.instructor.name}
                className="instructor-image rounded-circle"
                style={{ width: 120, height: 120, objectFit: "cover" }}
              />
            ) : (
              <div className="avatar-placeholder instructor-image"></div>
            )}
            <div>
              <h5 style={{ fontWeight: 700 }}>{props.instructor.name}</h5>
              <p style={{ fontWeight: 700 }}>Music Teacher, {props.instructor.title || "Expert"}</p>
            </div>
          </div>

          <div className="pl-1">
            {props.instructor.location && (
              <p style={{ fontWeight: 700 }}><strong>Location: {props.instructor.location}</strong></p>
            )}

            {props.instructor.languages && Array.isArray(props.instructor.languages) && props.instructor.languages.length > 0 && (
              <p>
                <strong style={{ fontWeight: 700 }}>Speaks: </strong>
                <span>{props.instructor.languages.join(", ")}</span>
              </p>
            )}

            {props.instructor.instruments && Array.isArray(props.instructor.instruments) && props.instructor.instruments.length > 0 && (
              <p>
                <strong style={{ fontWeight: 700 }}>Instruments: </strong>
                <span>{props.instructor.instruments.join(", ")}</span>
              </p>
            )}

            {props.instructor.education && (
              <p className="mt-3 mb-1">
                <strong style={{ fontWeight: 700 }}>Education: </strong>
                <span>{props.instructor.education}</span>
              </p>
            )}

            {props.instructor.performances && (
              <>
                <p className="mb-1" style={{ fontWeight: 700 }}><strong>Performance Experience:</strong></p>
                <p>{props.instructor.performances}</p>
              </>
            )}

            {props.instructor.experience && (
              <>
                <p className="mb-1" style={{ fontWeight: 700 }}><strong>Teaching Experience:</strong></p>
                <p>{props.instructor.experience}</p>
              </>
            )}

            {props.instructor.philosophy && (
              <>
                <p className="mb-1" style={{ fontWeight: 700 }}><strong>Teaching Philosophy:</strong></p>
                <p>{props.instructor.philosophy}</p>
              </>
            )}
          </div>

          <div className="pt-2 pl-1">
            <p className="info-panel-title" style={{ fontWeight: 700 }}>Lessons Prices</p>
            <div className="lesson-price-panel_row">
              <div className="lesson-price-panel_col">
                <p className="lesson-price-panel_price" style={{ fontWeight: 700 }}>${props.instructor.thirtyprice}</p>
                <p className="panel_info" style={{ fontWeight: 700 }}>Book four 30 minute lessons</p>
              </div>
              <div className="lesson-price-panel_col">
                <p className="lesson-price-panel_price" style={{ fontWeight: 700 }}>${props.instructor.sixtyprice}</p>
                <p className="panel_info" style={{ fontWeight: 700 }}>Book four 60 minute lessons</p>
              </div>
            </div>
          </div>

          <Button
            color="danger"
            onClick={(e) => {
              e.preventDefault();
              props.bookModalTrigger(e, props.instructor);
            }}
            className="mt-3 w-100 mb-3"
          >
            Book Now
          </Button>
        </Col>

        {/* Right Column */}
        <Col md="6">
          <h3 className="text-danger p-0">Get to know {props.instructor.name}</h3>
          <div>
            {props.instructor.shortbio
              ? props.instructor.shortbio
                  .replace(/<[^>]+>/g, "")
                  .replace(/&nbsp;/g, " ")
                  .replace(/&amp;/g, " & ")
                  .replace(/&rsquo;/g, "'")
              : null}
          </div>
        </Col>
      </Row>
    </div>
    </>
  );
}

export default ProfileModal;